export default __webpack_public_path__ + "static/STAYTRUE_GREEN-e4213907c22b8b188e9a014484fcd603.png";